import React from 'react';
import { Box, Typography } from '@mui/material';
import { statusStyles } from '../../styles/tokens';

const formatLabel = (status) => {
  if (!status) return '—';
  return String(status)
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

const StatusBadge = ({ status, label }) => {
  const key = String(status || '').toUpperCase();
  const style = statusStyles[key] || statusStyles.PENDING;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.625,
        px: 1.375,
        py: 0.5,
        borderRadius: 999,
        bgcolor: style.bg,
        border: '1px solid',
        borderColor: style.border,
        boxShadow: `0 1px 3px ${style.border}40`,
      }}
    >
      <Box
        sx={{
          width: 7,
          height: 7,
          borderRadius: '50%',
          bgcolor: style.dot || style.color,
          flexShrink: 0,
          boxShadow: `0 0 6px ${style.dot || style.color}80`,
        }}
      />
      <Typography sx={{ fontSize: '0.75rem', fontWeight: 400, color: style.color, lineHeight: 1.4, letterSpacing: '0.01em' }}>
        {label || formatLabel(status)}
      </Typography>
    </Box>
  );
};

export default StatusBadge;
